import { render, staticRenderFns } from "./match-details-modal-header.vue?vue&type=template&id=5d2b46a1&scoped=true&"
import script from "./match-details-modal-header.vue?vue&type=script&lang=ts&"
export * from "./match-details-modal-header.vue?vue&type=script&lang=ts&"
import style0 from "./match-details-modal-header.vue?vue&type=style&index=0&id=5d2b46a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b46a1",
  null
  
)

export default component.exports